import Vue from 'vue'
import Skeleton from '@/components/common/Skeleton.vue'

export default new Vue({
  components: {
    Skeleton
  },
  render: h => h(Skeleton)
})
